<template>
	<article class="single-event-block" v-if="data && data.acf" :class="'color-' + data.acf.category">
		<WpLink class="post-event-link" :url="data.link" :title="data.title">
			<div class="post-featured">
				<WpImage
					size="medium_large"
					class="featured"
					v-if="data.featured_image"
					:image="data.featured_image"
					cover
					background
				/>
				<div v-else class="featured dummy-image">
					<div class="img"></div>
				</div>
			</div>

			<div class="post-info font-size--16 padding-lg">
				<div class="event-meta-row">
					<span v-if="data.acf.type" class="taxonomy">
						{{ data.acf.type.name }}
					</span>
					<span v-if="eventDatetime" class="date">
						{{ eventDatetime.format('DD.MM.YYYY') }}
					</span>
					<span
						v-if="
							eventDatetimeEnd &&
							eventDatetimeEnd.format('DD.MM.YYYY') !== eventDatetime.format('DD.MM.YYYY')
						"
						class="date date-end"
					>
						- {{ eventDatetimeEnd.format('DD.MM.YYYY') }}
					</span>
					<span v-if="displayTime && !eventDatetimeEnd" class="time">at {{ displayTime }}</span>
					<span v-if="organizator" class="organizator">by {{ organizator }}</span>
				</div>
				<h4 class="titler font-size--26" v-html="data.title"></h4>
			</div>

			<div class="category-icon padding-right-lg" v-html="iconType(data.acf.category)"></div>
		</WpLink>
	</article>
</template>

<script>
import WpImage from '@/components/elements/WpImage'
import WpLink from '@/components/elements/WpLink'

import { system, fish, leaft, gear, heartch } from '@/icons'

import moment from 'moment'
moment.locale('nb-NO')

export default {
	props: ['data'],
	data() {
		return {
			eventDatetime: '',
			eventDatetimeEnd: '',
		}
	},
	components: {
		WpImage,
		WpLink,
	},
	computed: {
		displayTime() {
			const startTime = this.data.acf.time_from || ''
			const endTime = this.data.acf.time_to || ''

			const startTimeNumber = startTime ? Number(startTime.replaceAll(':', '')) : ''
			const endTimeNumber = endTime ? Number(endTime.replaceAll(':', '')) : ''

			if (startTimeNumber < endTimeNumber && endTimeNumber) {
				return startTime.substr(0, 5) + ' - ' + endTime.substr(0, 5)
			} else if (endTimeNumber && startTimeNumber === endTimeNumber) {
				return startTime.substr(0, 5)
			} else {
				return startTime.substr(0, 5)
			}
		},
		organizator() {
			if (this.data.acf.org_type === 'external') return this.data.acf.org_name
			if (this.data.acf.org_type === 'internal') return 'The Life Science Cluster'
			return ''
		},
	},
	created() {
		this.eventDatetime = this.data.acf.event_datetime ? moment(this.data.acf.event_datetime) : false
		this.eventDatetimeEnd = this.data.acf.event_datetime_copy ? moment(this.data.acf.event_datetime_copy) : false
	},
	methods: {
		iconType(type) {
			switch (type) {
				case 'blue':
					return fish()
					break
				case 'red':
					return heartch()
					break
				case 'green':
					return leaft()
					break
				case 'purple':
					return gear()
					break
				default:
					return system()
					break
			}
		},
	},
}
</script>

<style lang="scss">
@import '@/assets/vars.scss';
@import '@/assets/mixins.scss';

.single-event-block {
	.post-event-link {
		display: flex;
		text-decoration: none;
		border-radius: $radius;
		min-height: 168px;
		@include mquery($phone) {
			flex-direction: column;
		}
	}
	.event-meta-row {
		span {
			display: inline-block;
			margin-right: 5px;
		}
	}
	.post-featured {
		min-width: 300px;
		max-width: 300px;
		@include mquery($phone) {
			max-width: 100%;
			min-width: 100%;
			min-height: 150px;
		}
	}
	.wp-image-vue,
	.wp-image-vue div.image {
		border-top-right-radius: 0;
		border-bottom-right-radius: 0;
		padding: 0;
		height: 100%;
	}
	.wp-image-vue div.image {
		@include mquery($phone) {
			border-top-right-radius: $radius;
			border-bottom-right-radius: 0;
			border-bottom-left-radius: 0;
			padding-bottom: 50%;
		}
	}
	.post-event-link {
		background-color: var(--gray);
		transition: box-shadow 0.15s ease-in-out;
		position: relative;
		&:hover,
		&:focus {
			box-shadow: 0 0 0 2px var(--dark);
		}
	}

	&.color-red {
		.post-event-link {
			background-color: var(--redLight);
			color: var(--red);
			&:hover,
			&:focus {
				box-shadow: 0 0 0 2px var(--red);
			}
		}
	}
	&.color-blue {
		.post-event-link {
			background-color: var(--blueLight);
			color: var(--blue);
			&:hover,
			&:focus {
				box-shadow: 0 0 0 2px var(--blue);
			}
		}
	}
	&.color-purple {
		.post-event-link {
			background-color: var(--purpleLight);
			color: var(--purple);
			&:hover,
			&:focus {
				box-shadow: 0 0 0 2px var(--blue);
			}
		}
	}
	&.color-green {
		.post-event-link {
			background-color: var(--greenLight);
			color: var(--green);
			&:hover,
			&:focus {
				box-shadow: 0 0 0 2px var(--green);
			}
		}
	}
	.post-info {
		flex-grow: 1;
	}
	.category-icon {
		align-self: center;
		svg {
			width: 66px;
			height: 66px;
		}
		@include mquery($tablet) {
			svg {
				width: 44px;
				height: 44px;
			}
		}

		@include mquery($phone) {
			position: absolute;
			bottom: 15px;
			right: 15px;
			opacity: 0.9;
			padding-right: 0;
		}
	}
	.titler {
		margin-bottom: 0;
		margin-top: 10px;
	}
}
</style>
